export default {
  filters: {
    sac_status_sac: 'Status de atendimento',
    sac_status_other: 'Status novo',
    names: 'Grupos',
    channels_listening: 'Canais Listening',
    channels_proprietary: 'Canais Proprietário',
    themes: 'Temas',
    pids: 'Publicações com id',
    genders: 'Gênero',
    polarities: 'Sentimento',
    tags: 'Tags',
    favorite: 'Publicações checadas',
    dark_post: 'Tipo de Publicação',
    sac_last_status: 'Status antigo',
    sac_replier: 'Respondentes',
    sac_type: 'Interação',
    pages: 'Páginas',
    uids: 'Autores',
    contracts: 'Contrato',
    bots: 'Bot',
    category: 'Categoria',
  },
  selected: 'selecionado',
  selectedPlural: 'selecionados',
};
